class S71Destinations extends HTMLElement {
  connectedCallback() {
    this.pending = 0;

    this.addEventListener('click', (event) => {
      const header = event.target.closest('[data-s71-accordion-header]');
      if (header && this.contains(header)) this.toggle(header);
    });

    this.querySelectorAll('[data-s71-accordion-header]').forEach((header) => {
      const body = this.body(header);
      if (!body) return;
      body.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'height' || event.target !== body) return;
        body.style.height = header.getAttribute('aria-expanded') === 'true' ? 'auto' : '';
        this.settle();
      });
      if (header.dataset.s71Open === 'true') {
        header.setAttribute('aria-expanded', 'true');
        body.style.height = 'auto';
      }
    });
  }

  body(header) {
    return this.querySelector('#' + CSS.escape(header.getAttribute('aria-controls')));
  }

  isCategory(header) {
    return header.classList.contains('s71-destinations__header');
  }

  ancestors(body) {
    const list = [];
    let parent = body.parentElement?.closest('.s71-destinations__body');
    while (parent) {
      list.push(parent);
      parent = parent.parentElement?.closest('.s71-destinations__body');
    }
    return list;
  }

  start() {
    this.pending += 1;
    this.classList.add('s71-destinations--animating');
  }

  settle() {
    this.pending = Math.max(0, this.pending - 1);
    if (this.pending === 0) this.classList.remove('s71-destinations--animating');
  }

  toggle(header) {
    const body = this.body(header);
    if (!body) return;
    const open = header.getAttribute('aria-expanded') === 'true';

    if (!open && this.isCategory(header)) {
      this.querySelectorAll('.s71-destinations__header[aria-expanded="true"]').forEach((other) => {
        if (other !== header) this.close(other, this.body(other));
      });
    }

    this.ancestors(body).forEach((parent) => {
      parent.style.transition = 'none';
      parent.style.height = 'auto';
      requestAnimationFrame(() => {
        parent.style.transition = '';
      });
    });

    if (open) this.close(header, body);
    else this.open(header, body);
  }

  open(header, body) {
    this.start();
    header.setAttribute('aria-expanded', 'true');
    body.style.height = body.scrollHeight + 'px';
  }

  close(header, body) {
    if (!body) return;
    this.start();
    body.style.height = body.scrollHeight + 'px';
    requestAnimationFrame(() => {
      header.setAttribute('aria-expanded', 'false');
      body.style.height = '0px';
    });
  }
}

if (!customElements.get('s71-destinations')) {
  customElements.define('s71-destinations', S71Destinations);
}
